module.exports = __webpack_public_path__ + "img/item6-6.7fed0bdb.png";